import React from 'react';
import { isExtensionInstalled, getExtensionOptions } from '../../../utils/tiptap';
import s from './CharacterCount.scss';
const CharacterCount = ({ editor })=>{
    if (!isExtensionInstalled(editor, 'characterCount')) {
        return null;
    }
    const options = getExtensionOptions(editor, 'characterCount');
    const count = editor.storage.characterCount.characters();
    return /*#__PURE__*/ React.createElement("span", {
        className: s['root']
    }, parseInt(`${options.limit}`) - count);
};
CharacterCount.displayName = 'CharacterCount';
export default CharacterCount;

//# sourceMappingURL=CharacterCount.js.map